<template>
  <div @click="toggle"
       :class="['w-14 h-8 flex items-center rounded-full p-1 cursor-pointer', isActive ? 'bg-theme-primary' : 'bg-gray-300']">
    <div :class="['bg-white w-6 h-6 rounded-full shadow-md transition-all duration-300', isActive ? 'translate-x-6' : '']"></div>
  </div>
</template>

<script>
export default {
  name: 'ToggleControl',
  props: {
    modelValue: {
      type: [Boolean, Number],
      default: 0
    }
  },
  computed: {
    isActive() {
      return this.modelValue === 1 || this.modelValue === true;
    }
  },
  methods: {
    toggle() {
      const newValue = this.isActive ? 0 : 1;
      this.$emit('update:modelValue', newValue);
    }
  }
};
</script>

<style scoped>
.translate-x-6 {
  transform: translateX(24px);
}
.transition-all {
  transition: all 0.3s;
}
</style>
